const Register = () => {
  return <></>;
};

export default Register;
